// Ikara Scents Logo Component with Spiral Icon
const IkaraLogo = ({ className = "", showIcon = true, variant = "light" }) => {
  // Colors based on variant
  const textColor = variant === "light" ? "#1A1A1A" : "#F9F6F0";
  const iconColor = variant === "light" ? "#C4A962" : "#D4B978";
  
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {showIcon && (
        <svg 
          viewBox="0 0 40 40" 
          className="w-8 h-8 md:w-10 md:h-10"
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Spiral/Swirl Icon */}
          <path 
            d="M20 8C20 8 28 10 30 18C32 26 26 32 20 32C14 32 8 26 10 18C11.5 12 16 10 20 12C24 14 26 18 24 22C22 26 18 26 16 24C14 22 14 18 17 16C19 14.5 22 15 22 18"
            stroke={iconColor}
            strokeWidth="2"
            strokeLinecap="round"
            fill="none"
          />
        </svg>
      )}
      <span 
        className="font-heading text-2xl md:text-2xl"
        style={{ 
          color: textColor,
          fontStyle: 'italic',
          fontWeight: 400,
          letterSpacing: '0.05em'
        }}
      >
        Ikara Scents
      </span>
    </div>
  );
};

export default IkaraLogo;
